// @flow

import React from 'react';
import { Dropdown, Form, Modal, Button } from 'semantic-ui-react';
import type {
  Question,
  QuestionType,
  QuestionContentDescriptor,
} from '../../types';

type Props = {
  question: Question,
  content: QuestionContentDescriptor,
  onChange: (type: QuestionType) => void,
};

type State = {
  currentType: ?QuestionType,
};

const TYPE_OPTIONS = [
  {
    value: 'short-text',
    text: 'Texte court',
    icon: 'window minimize',
  },
  {
    value: 'long-text',
    text: 'Text long',
    icon: 'align justify',
  },
  {
    value: 'dropdown',
    text: 'Liste déroulante',
    icon: 'caret down',
  },
  {
    value: 'radio',
    text: 'Choix unique',
    icon: 'circle outline',
  },
  {
    value: 'checkbox',
    text: 'Choix multiple',
    icon: 'check square outline',
  },
  {
    value: 'images',
    text: "Choix d'images",
    icon: 'image outline',
  },
  {
    value: 'rating',
    text: 'Evaluation',
    icon: 'star outline',
  },
];

class QuestionTypeSelector extends React.Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  onChange = (_, { value }) => {
    const { question, content, onChange } = this.props;
    if (content.type === value) {
      return;
    }

    if (content.hasChanged || !question.isNew) {
      this.setState({
        currentType: value,
      });
    } else {
      onChange(value);
    }
  };

  onConfirm = () => {
    const { currentType } = this.state;

    this.setState(
      {
        currentType: null,
      },
      () => this.props.onChange(currentType)
    );
  };

  onCloseModal = () => this.setState({ currentType: null });

  render() {
    const { content } = this.props;
    const { currentType } = this.state;

    return (
      <Form.Field required>
        <label>Choisissez le type de réponse</label>
        <Dropdown
          fluid
          selection
          value={content.type}
          options={TYPE_OPTIONS}
          onChange={this.onChange}
        />
        <Modal
          size="small"
          open={!!currentType}
          closeIcon
          onClose={this.onCloseModal}
        >
          <Modal.Header>Changement de type de question</Modal.Header>
          <Modal.Content>
            <p>
              Vous êtes sur le point de changer le type de cette question.<br />
              Vos modifications en cours seront perdues.<br />
              <br />
              Êtes-vous sûr(e) de vouloir continuer ?
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button content="Annuler" onClick={this.onCloseModal} />
            <Button
              color="red"
              icon="save"
              content="Confirmer"
              labelPosition="right"
              onClick={this.onConfirm}
            />
          </Modal.Actions>
        </Modal>
      </Form.Field>
    );
  }
}

export default QuestionTypeSelector;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionTypeSelector.js